import React from 'react'

const SvgCompany = props => (
  <svg id='company_svg__connect_4' x={0} y={0} viewBox='0 0 484 458' xmlSpace='preserve' {...props}>
    <style>
      {
        '.company_svg__st1{fill-rule:evenodd;clip-rule:evenodd}.company_svg__st1,.company_svg__st2{fill:#ff8a00}.company_svg__st3{font-family:&apos;SourceHanSansCN-Regular-GBpc-EUC-H&apos;}.company_svg__st4{font-size:12px}.company_svg__st5{fill:#fff;stroke:#999;stroke-dasharray:4,2}.company_svg__st6{fill:#fd5c1f}.company_svg__st7{fill:#fff}.company_svg__st8{font-family:&apos;SourceHanSansCN-Normal-GBpc-EUC-H&apos;}.company_svg__st9{fill:#333}.company_svg__st10{font-size:14px}.company_svg__st12{fill:#f4f8fa}'
      }
    </style>
    <path
      id='company_svg__\u5706\u89D2\u77E9\u5F62_4_\u62F7\u8D1D_2'
      d='M7 146h290c2.76 0 5 2.24 5 5v139c0 2.76-2.24 5-5 5H7c-2.76 0-5-2.24-5-5V151c0-2.76 2.24-5 5-5z'
      fill='#f4f8fa'
      stroke='#999'
      strokeDasharray='4,2'
    />
    <g id='company_svg__arrow5'>
      <path
        id='company_svg__\u5F62\u72B6_41_\u62F7\u8D1D_12'
        className='company_svg__st1'
        d='M152.72 360.45h4.29l-5 6.46-5-6.46h4.29v-23.1H147l5-6.46 5 6.46h-4.28v23.1z'
      />
      <text
        id='company_svg__MSTP_\u4E13\u7EBF'
        transform='translate(161 353)'
        className='company_svg__st2 company_svg__st3 company_svg__st4'
      >
        {'MSTP \u4E13\u7EBF'}
      </text>
      <path
        id='company_svg__\u5F62\u72B6_41_\u62F7\u8D1D_14'
        className='company_svg__st1'
        d='M152.72 139.45h4.29l-5 6.46-5-6.46h4.29v-23.1H147l5-6.46 5 6.46h-4.28v23.1z'
      />
      <text
        id='company_svg__MSTP_\u4E13\u7EBF_\u62F7\u8D1D'
        transform='translate(161 132)'
        className='company_svg__st2 company_svg__st3 company_svg__st4'
      >
        {'MSTP \u4E13\u7EBF'}
      </text>
    </g>
    <g id='company_svg__\u4F01\u4E1A'>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_4'
        className='company_svg__st5'
        d='M7 19h290c2.76 0 5 2.24 5 5v80c0 2.76-2.24 5-5 5H7c-2.76 0-5-2.24-5-5V24c0-2.76 2.24-5 5-5z'
      />
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_4_\u62F7\u8D1D_4'
        className='company_svg__st5'
        d='M399 70h80c2.76 0 5 2.24 5 5v290c0 2.76-2.24 5-5 5h-80c-2.76 0-5-2.24-5-5V75c0-2.76 2.24-5 5-5z'
      />
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_3'
        className='company_svg__st6'
        d='M31 32.75h50c2.76 0 5 2.24 5 5v50.06c0 2.76-2.24 5-5 5H31c-2.76 0-5-2.24-5-5V37.75c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u670D\u52A1\u5668'
        transform='translate(38 86.795)'
        className='company_svg__st7 company_svg__st3 company_svg__st4'
      >
        {'\u670D\u52A1\u5668'}
      </text>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D'
        className='company_svg__st6'
        d='M127 32.75h50c2.76 0 5 2.24 5 5v50.06c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5V37.75c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u6570\u636E\u5E93'
        transform='translate(134 86.795)'
        className='company_svg__st7 company_svg__st3 company_svg__st4'
      >
        {'\u6570\u636E\u5E93'}
      </text>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_13'
        className='company_svg__st6'
        d='M414 98.75h50c2.76 0 5 2.24 5 5v50.06c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50.06c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u6570\u636E\u5E93_\u62F7\u8D1D'
        transform='translate(421 152.795)'
        className='company_svg__st7 company_svg__st8 company_svg__st4'
      >
        {'\u6570\u636E\u5E93'}
      </text>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_14'
        className='company_svg__st6'
        d='M414 188.75h50c2.76 0 5 2.24 5 5v50.06c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50.06c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u670D\u52A1\u5668_\u62F7\u8D1D'
        transform='translate(421 242.795)'
        className='company_svg__st7 company_svg__st8 company_svg__st4'
      >
        {'\u670D\u52A1\u5668'}
      </text>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_8'
        className='company_svg__st6'
        d='M217 32.75h50c2.76 0 5 2.24 5 5v50.06c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5V37.75c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u4E2D\u95F4\u4EF6'
        transform='translate(223 86.795)'
        className='company_svg__st7 company_svg__st3 company_svg__st4'
      >
        {'\u4E2D\u95F4\u4EF6'}
      </text>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_15'
        className='company_svg__st6'
        d='M414 273.75h50c2.76 0 5 2.24 5 5v50.06c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50.06c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u4E2D\u95F4\u4EF6_\u62F7\u8D1D'
        transform='translate(421 327.795)'
        className='company_svg__st7 company_svg__st8 company_svg__st4'
      >
        {'\u4E2D\u95F4\u4EF6'}
      </text>
    </g>
    <g id='company_svg__\u4F01\u4E1A_\u62F7\u8D1D'>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_4-2'
        className='company_svg__st5'
        d='M7 368h290c2.76 0 5 2.24 5 5v80c0 2.76-2.24 5-5 5H7c-2.76 0-5-2.24-5-5v-80c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u7528\u6237\u673A\u67DCA'
        transform='translate(124.358 440.95)'
        className='company_svg__st7 company_svg__st3 company_svg__st4'
      >
        {'\u7528\u6237\u673A\u67DCA'}
      </text>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_2'
        className='company_svg__st6'
        d='M217 386.94h50c2.76 0 5 2.24 5 5V442c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50.06c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u6570\u636E\u5E93C'
        transform='translate(220.172 440.984)'
        className='company_svg__st7 company_svg__st8 company_svg__st4'
      >
        {'\u6570\u636E\u5E93C'}
      </text>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_11'
        className='company_svg__st6'
        d='M127 386.94h50c2.76 0 5 2.24 5 5V442c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50.06c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u6570\u636E\u5E93B_\u62F7\u8D1D'
        transform='translate(130.058 440.984)'
        className='company_svg__st7 company_svg__st8 company_svg__st4'
      >
        {'\u6570\u636E\u5E93B'}
      </text>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_12'
        className='company_svg__st6'
        d='M35 386.94h50c2.76 0 5 2.24 5 5V442c0 2.76-2.24 5-5 5H35c-2.76 0-5-2.24-5-5v-50.06c0-2.76 2.24-5 5-5z'
      />
      <text
        id='company_svg__\u6570\u636E\u5E93A'
        transform='translate(38.358 440.984)'
        className='company_svg__st7 company_svg__st8 company_svg__st4'
      >
        {'\u6570\u636E\u5E93A'}
      </text>
    </g>
    <g id='company_svg__\u956D\u901F\u4E91'>
      <path
        id='company_svg__\u5706\u89D2\u77E9\u5F62_4_\u62F7\u8D1D'
        className='company_svg__st5'
        d='M17 176h270c2.76 0 5 2.24 5 5v80c0 2.76-2.24 5-5 5H17c-2.76 0-5-2.24-5-5v-80c0-2.76 2.24-5 5-5z'
      />
      <g id='company_svg__\u7EC4_30'>
        <path
          id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_3'
          className='company_svg__st6'
          d='M35 188.84h50c2.76 0 5 2.24 5 5v50.03c0 2.76-2.24 5-5 5H35c-2.76 0-5-2.24-5-5v-50.03c0-2.76 2.24-5 5-5z'
        />
        <text
          id='company_svg__\u63A5\u5165\u70B9A'
          transform='translate(38.358 242.88)'
          className='company_svg__st7 company_svg__st3 company_svg__st4'
        >
          {'\u63A5\u5165\u70B9A'}
        </text>
      </g>
      <g id='company_svg__\u7EC4_29'>
        <path
          id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_4'
          className='company_svg__st6'
          d='M127 188.84h50c2.76 0 5 2.24 5 5v50.03c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50.03c0-2.76 2.24-5 5-5z'
        />
        <text
          id='company_svg__\u63A5\u5165\u70B9B'
          transform='translate(130.058 242.88)'
          className='company_svg__st7 company_svg__st3 company_svg__st4'
        >
          {'\u63A5\u5165\u70B9B'}
        </text>
        <path
          id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_10'
          className='company_svg__st6'
          d='M217 188.84h50c2.76 0 5 2.24 5 5v50.03c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50.03c0-2.76 2.24-5 5-5z'
        />
        <text
          id='company_svg__\u63A5\u5165\u70B9C'
          transform='translate(220.172 242.88)'
          className='company_svg__st7 company_svg__st3 company_svg__st4'
        >
          {'\u63A5\u5165\u70B9C'}
        </text>
      </g>
      <g id='company_svg__\u7EC4_28'>
        <path
          id='company_svg__\u5706\u89D2\u77E9\u5F62_3_\u62F7\u8D1D_9'
          className='company_svg__st6'
          d='M127 269.84h50c2.76 0 5 2.24 5 5v50.03c0 2.76-2.24 5-5 5h-50c-2.76 0-5-2.24-5-5v-50.03c0-2.76 2.24-5 5-5z'
        />
        <text
          id='company_svg__Edge_\u8282\u70B9'
          transform='translate(124.862 323.88)'
          className='company_svg__st7 company_svg__st3 company_svg__st4'
        >
          {'Edge \u8282\u70B9'}
        </text>
      </g>
      <text
        id='company_svg__\u956D\u901F\u4E91\u9AA8\u7F51'
        transform='translate(12 166.837)'
        className='company_svg__st9 company_svg__st8 company_svg__st10'
      >
        {'\u956D\u901F\u4E91\u9AA8\u7F51'}
      </text>
      <text
        id='company_svg__\u956D\u901F\u4E91\u5E73\u53F0'
        transform='translate(0 134.837)'
        className='company_svg__st9 company_svg__st3 company_svg__st10'
      >
        {'\u956D\u901F\u4E91\u5E73\u53F0'}
      </text>
      <text
        id='company_svg__\u5206\u90E8\u6570\u636E\u4E2D\u5FC3'
        transform='translate(0 359.908)'
        className='company_svg__st9 company_svg__st8'
        fontSize={13.992}
      >
        {'\u5206\u90E8\u6570\u636E\u4E2D\u5FC3'}
      </text>
      <text
        id='company_svg__\u603B\u90E8\u6570\u636E\u4E2D\u5FC3'
        transform='translate(394 59.908)'
        className='company_svg__st9 company_svg__st8 company_svg__st10'
      >
        {'\u603B\u90E8\u6570\u636E\u4E2D\u5FC3'}
      </text>
      <text
        id='company_svg__\u751F\u4EA7\u4E2D\u5FC3'
        transform='translate(0 11.751)'
        className='company_svg__st9 company_svg__st8 company_svg__st10'
      >
        {'\u751F\u4EA7\u4E2D\u5FC3'}
      </text>
    </g>
    <path
      id='company_svg__\u5F62\u72B6_41_\u62F7\u8D1D_13'
      className='company_svg__st1'
      d='M311.45 218.69v4.29l-6.45-5.01 6.45-5.01v4.29h73.1v-4.29l6.45 5.01-6.45 5.01v-4.29h-73.1z'
    />
    <path
      id='company_svg__\u5F62\u72B6_41_\u62F7\u8D1D_15'
      className='company_svg__st1'
      d='M119 305.01l-6.45-5v4.29H59.72v-30.83H64l-5-6.45-5 6.45h4.28v30.82H58v1.43h.28v.29h1.44v-.29h52.83v4.29l6.45-5z'
    />
    <path
      id='company_svg__\u5F62\u72B6_41_\u62F7\u8D1D_16'
      className='company_svg__st1'
      d='M184 305.01l6.45-5v4.29h52.83v-30.83H239l5-6.45 5 6.45h-4.28v30.82h.28v1.43h-.28v.29h-1.43v-.29h-52.83v4.29l-6.46-5z'
    />
    <text
      id='company_svg__MSTP_\u4E13\u7EBF-2'
      transform='translate(318.948 210)'
      className='company_svg__st2 company_svg__st3 company_svg__st4'
    >
      {'MSTP \u4E13\u7EBF'}
    </text>
    <text
      id='company_svg__\u53CC\u8DEF\u7531'
      transform='translate(62 320.927)'
      className='company_svg__st2 company_svg__st3 company_svg__st4'
    >
      {'\u53CC\u8DEF\u7531'}
    </text>
    <text
      id='company_svg__\u53CCPOP'
      transform='translate(199.964 319.927)'
      className='company_svg__st2 company_svg__st3 company_svg__st4'
    >
      {'\u53CCPOP'}
    </text>
    <path
      className='company_svg__st7'
      d='M441.42 301.59c-2.01 1.06-3.11 1.05-4.7.28-1.59-.77-14.76-6.38-14.76-6.38v4.06c0 .35.48.72 1.38 1.15 1.8.88 11.81 5 13.38 5.76 1.58.76 2.69.78 4.7-.28 2.01-1.05 11.4-5 13.22-5.95.92-.47 1.33-.89 1.33-1.22V295c-.01.01-12.55 5.52-14.55 6.59zm0 0'
    />
    <path
      className='company_svg__st7'
      d='M441.49 307.59c-2.01 1.06-3.11 1.05-4.7.28-1.59-.77-14.76-6.38-14.76-6.38v4.06c0 .35.48.72 1.38 1.15 1.8.88 11.81 5 13.38 5.76 1.58.76 2.69.77 4.7-.28 2.01-1.05 11.4-5 13.22-5.95.92-.49 1.33-.87 1.33-1.21v-4.01s-12.55 5.51-14.55 6.58zm14.53-18.19c0-.34-.44-.64-1.35-.97-1.77-.64-11.11-4.31-12.92-4.95-1.81-.65-2.52-.62-4.62.12s-12.05 4.58-13.82 5.28c-.89.35-1.33.67-1.3 1.01v3.88s13.18 5.47 14.77 6.22c1.59.75 2.69.75 4.7-.27 2.01-1.02 14.54-6.48 14.54-6.48v-3.84zm-4.4.1l-5.17 2.01-4.65-1.82 5.15-2.02 4.67 1.83zm-9.54 1.93l-2.38 3.45-5.5-2.27 7.88-1.18zm-4.14-5.25l-.76-1.39 2.37.92 2.24-.73-.61 1.43 2.28.83-2.95.3-.65 1.58-1.06-1.75-3.4-.3 2.54-.89zm-5.86 1.95c2.33 0 4.21.72 4.21 1.61 0 .9-1.89 1.61-4.21 1.61-2.33 0-4.21-.72-4.21-1.61-.01-.9 1.88-1.61 4.21-1.61zm0 0M243.35 58.13c-2.01 1.06-3.11 1.05-4.7.28-1.59-.77-14.76-6.38-14.76-6.38v4.06c0 .35.48.72 1.38 1.15 1.8.88 11.81 5 13.38 5.76 1.58.76 2.69.78 4.7-.28 2.01-1.05 11.4-5 13.22-5.95.92-.47 1.33-.89 1.33-1.22v-4.01c-.01.01-12.56 5.52-14.55 6.59zm0 0'
    />
    <path
      className='company_svg__st7'
      d='M243.42 64.13c-2.01 1.06-3.11 1.05-4.7.28-1.59-.77-14.76-6.38-14.76-6.38v4.06c0 .35.48.72 1.38 1.15 1.8.88 11.81 5 13.38 5.76 1.58.76 2.69.77 4.7-.28 2.01-1.05 11.4-5 13.22-5.95.92-.49 1.33-.87 1.33-1.21v-4.01s-12.55 5.51-14.55 6.58zm14.53-18.2c0-.34-.44-.64-1.35-.97-1.77-.64-11.11-4.31-12.92-4.95-1.81-.65-2.52-.62-4.62.12s-12.05 4.58-13.82 5.28c-.89.35-1.33.67-1.3 1.01v3.88s13.18 5.47 14.77 6.22c1.59.75 2.69.75 4.7-.27 2.01-1.02 14.54-6.48 14.54-6.48v-3.84zm-4.4.11l-5.17 2.01-4.65-1.82 5.15-2.02 4.67 1.83zm-9.54 1.93l-2.38 3.45-5.5-2.27 7.88-1.18zm-4.14-5.26l-.76-1.39 2.37.92 2.24-.73-.61 1.43 2.28.83-2.95.3-.65 1.58-1.06-1.75-3.4-.3 2.54-.89zM234 44.66c2.33 0 4.21.72 4.21 1.61 0 .9-1.89 1.61-4.21 1.61-2.33 0-4.21-.72-4.21-1.61 0-.89 1.89-1.61 4.21-1.61zm0 0M441.99 116.36v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.94 0-3.77-.26-5.23-.73zM439.95 109.02c.02 1.13 3.12 2.4 7.27 2.4 4.16 0 7.28-1.27 7.28-2.41 0-1.14-3.11-2.41-7.28-2.41-4.16 0-7.26 1.27-7.27 2.4v.02zM424.5 125.58v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.67-8.26-1.92z'
    />
    <path
      className='company_svg__st7'
      d='M424.5 120.54v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.66-8.26-1.92zM441.99 121.06v3.68c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.48 1.13-4.44 1.73-7.27 1.73-1.94 0-3.77-.26-5.23-.73z'
    />
    <path
      className='company_svg__st7'
      d='M424.5 115.51v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92-3.25-.01-6.64-.67-8.26-1.92zM447.22 112.39c-2.84 0-5.79-.6-7.27-1.73v.88c1.25.58 2.04 1.35 2.04 2.3v1.49c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.47 1.14-4.43 1.74-7.27 1.74zM441.99 125.76v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.94 0-3.77-.26-5.23-.73zM424.5 130.62v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92-3.25-.01-6.64-.67-8.26-1.92z'
    />
    <path
      className='company_svg__st7'
      d='M432.76 111.22c-4.73 0-8.26 1.38-8.26 2.62 0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62c0-1.23-3.53-2.62-8.26-2.62z'
    />
    <g>
      <path
        className='company_svg__st7'
        d='M155.65 49.3v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41V48.3c-1.48 1.13-4.44 1.73-7.27 1.73-1.95.01-3.77-.25-5.23-.73zM153.61 41.97c.02 1.13 3.12 2.4 7.27 2.4 4.16 0 7.28-1.27 7.28-2.41 0-1.14-3.11-2.41-7.28-2.41-4.16 0-7.26 1.27-7.27 2.4v.02zM138.16 58.53v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92-3.25-.01-6.65-.67-8.26-1.92z'
      />
      <path
        className='company_svg__st7'
        d='M138.16 53.49v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.65-.66-8.26-1.92zM155.65 54v3.68c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41V53c-1.48 1.13-4.44 1.73-7.27 1.73-1.95.01-3.77-.25-5.23-.73z'
      />
      <path
        className='company_svg__st7'
        d='M138.16 48.45v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.65-.66-8.26-1.92zM160.88 45.34c-2.84 0-5.79-.6-7.27-1.73v.88c1.25.58 2.04 1.35 2.04 2.3v1.49c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41V43.6c-1.47 1.14-4.43 1.74-7.27 1.74zM155.65 58.71v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.95 0-3.77-.26-5.23-.73zM138.16 63.56v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.65-.66-8.26-1.92z'
      />
      <path
        className='company_svg__st7'
        d='M146.42 44.17c-4.73 0-8.26 1.38-8.26 2.62 0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62c0-1.24-3.53-2.62-8.26-2.62z'
      />
    </g>
    <g>
      <path
        className='company_svg__st7'
        d='M62.49 404.38v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.94.01-3.77-.25-5.23-.73zM60.45 397.05c.02 1.13 3.12 2.4 7.27 2.4 4.16 0 7.28-1.27 7.28-2.41 0-1.14-3.11-2.41-7.28-2.41-4.16 0-7.26 1.27-7.27 2.4v.02zM45 413.6v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.66-8.26-1.92z'
      />
      <path
        className='company_svg__st7'
        d='M45 408.57v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92-3.25-.01-6.64-.67-8.26-1.92zM62.49 409.08v3.68c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.48 1.13-4.44 1.73-7.27 1.73-1.94 0-3.77-.26-5.23-.73z'
      />
      <path
        className='company_svg__st7'
        d='M45 403.53v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.66-8.26-1.92zM67.72 400.41c-2.84 0-5.79-.6-7.27-1.73v.88c1.25.58 2.04 1.35 2.04 2.3v1.49c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.47 1.14-4.43 1.74-7.27 1.74zM62.49 413.78v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.94.01-3.77-.25-5.23-.73zM45 418.64v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.67-8.26-1.92z'
      />
      <path
        className='company_svg__st7'
        d='M53.26 399.25c-4.73 0-8.26 1.38-8.26 2.62 0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62c0-1.24-3.53-2.62-8.26-2.62z'
      />
    </g>
    <g>
      <path
        className='company_svg__st7'
        d='M153.16 404.38v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.95.01-3.77-.25-5.23-.73zM151.12 397.05c.02 1.13 3.12 2.4 7.27 2.4 4.16 0 7.28-1.27 7.28-2.41 0-1.14-3.11-2.41-7.28-2.41-4.16 0-7.26 1.27-7.27 2.4v.02zM135.67 413.6v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.65-.66-8.26-1.92z'
      />
      <path
        className='company_svg__st7'
        d='M135.67 408.57v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92-3.25-.01-6.65-.67-8.26-1.92zM153.16 409.08v3.68c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.48 1.13-4.44 1.73-7.27 1.73-1.95 0-3.77-.26-5.23-.73z'
      />
      <path
        className='company_svg__st7'
        d='M135.67 403.53v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.65-.66-8.26-1.92zM158.39 400.41c-2.84 0-5.79-.6-7.27-1.73v.88c1.25.58 2.04 1.35 2.04 2.3v1.49c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.47 1.14-4.43 1.74-7.27 1.74zM153.16 413.78v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.95.01-3.77-.25-5.23-.73zM135.67 418.64v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.65-.67-8.26-1.92z'
      />
      <path
        className='company_svg__st7'
        d='M143.93 399.25c-4.73 0-8.26 1.38-8.26 2.62 0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62c0-1.24-3.53-2.62-8.26-2.62z'
      />
    </g>
    <g>
      <path
        className='company_svg__st7'
        d='M244.49 404.38v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.94.01-3.77-.25-5.23-.73zM242.45 397.05c.02 1.13 3.12 2.4 7.27 2.4 4.16 0 7.28-1.27 7.28-2.41 0-1.14-3.11-2.41-7.28-2.41-4.16 0-7.26 1.27-7.27 2.4v.02zM227 413.6v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.66-8.26-1.92z'
      />
      <path
        className='company_svg__st7'
        d='M227 408.57v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92-3.25-.01-6.64-.67-8.26-1.92zM244.49 409.08v3.68c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.48 1.13-4.44 1.73-7.27 1.73-1.94 0-3.77-.26-5.23-.73z'
      />
      <path
        className='company_svg__st7'
        d='M227 403.53v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.66-8.26-1.92zM249.72 400.41c-2.84 0-5.79-.6-7.27-1.73v.88c1.25.58 2.04 1.35 2.04 2.3v1.49c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.06c-1.47 1.14-4.43 1.74-7.27 1.74zM244.49 413.78v3.67c1.39.5 3.27.79 5.23.79 4.16 0 7.27-1.27 7.27-2.41v-3.05c-1.48 1.13-4.44 1.73-7.27 1.73-1.94.01-3.77-.25-5.23-.73zM227 418.64v3.37c0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62v-3.37c-1.62 1.25-5.01 1.92-8.26 1.92s-6.64-.67-8.26-1.92z'
      />
      <path
        className='company_svg__st7'
        d='M235.26 399.25c-4.73 0-8.26 1.38-8.26 2.62 0 1.23 3.53 2.62 8.26 2.62s8.26-1.38 8.26-2.62c0-1.24-3.53-2.62-8.26-2.62z'
      />
    </g>
    <g>
      <path
        className='company_svg__st7'
        d='M450.42 195.86h-23.05c-1.88 0-3.38 1.48-3.38 3.25s1.51 3.25 3.38 3.25h23.05c1.84 0 3.38-1.45 3.38-3.25s-1.53-3.25-3.38-3.25zm-13.52 4h-9v-2h9v2zm4.67.26c-.64 0-1.16-.49-1.16-1.11s.51-1.11 1.16-1.11c.64 0 1.16.49 1.16 1.11-.01.58-.52 1.11-1.16 1.11zm4.11 0c-.64 0-1.16-.49-1.16-1.11s.51-1.11 1.16-1.11 1.16.49 1.16 1.11c.03.58-.49 1.11-1.16 1.11zm3.98 0c-.64 0-1.16-.49-1.16-1.11s.51-1.11 1.16-1.11 1.16.49 1.16 1.11c.03.58-.51 1.11-1.16 1.11zM450.42 203.36h-23.05c-1.84 0-3.38 1.45-3.38 3.25 0 1.77 1.51 3.25 3.38 3.25h23.05c1.84 0 3.38-1.45 3.38-3.25.01-1.8-1.53-3.25-3.38-3.25zm-13.52 4.5h-9v-2h9v2zm4.73.23c-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11.64 0 1.16.49 1.16 1.11.03.61-.52 1.11-1.16 1.11zm4.15 0c-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11.64 0 1.16.49 1.16 1.11-.01.61-.52 1.11-1.16 1.11zm3.98 0c-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11s1.16.49 1.16 1.11c0 .61-.52 1.11-1.16 1.11zM450.55 217.36c1.84 0 3.38-1.45 3.38-3.25 0-1.77-1.51-3.25-3.38-3.25H427.5c-1.84 0-3.38 1.45-3.38 3.25 0 1.77 1.51 3.25 3.38 3.25h10.9v3h-1.5v2h-12v2h12v1.5h5v-1.5h11v-2h-11v-2h-1.5v-3h10.15zm-.72-4.62c.64 0 1.16.49 1.16 1.11 0 .62-.51 1.11-1.16 1.11s-1.16-.49-1.16-1.11c0-.61.51-1.11 1.16-1.11zm-3.99 0c.64 0 1.16.49 1.16 1.11 0 .62-.51 1.11-1.16 1.11s-1.16-.49-1.16-1.11c0-.61.52-1.11 1.16-1.11zm-4.11 0c.64 0 1.16.49 1.16 1.11 0 .62-.51 1.11-1.16 1.11s-1.16-.49-1.16-1.11c-.03-.61.48-1.11 1.16-1.11zm-4.83 2.12h-9v-2h9v2z'
      />
    </g>
    <g>
      <path
        className='company_svg__st7'
        d='M67.46 39.55H44.41c-1.88 0-3.38 1.48-3.38 3.25s1.51 3.25 3.38 3.25h23.05c1.84 0 3.38-1.45 3.38-3.25.01-1.8-1.53-3.25-3.38-3.25zm-13.52 4h-9v-2h9v2zm4.66.26c-.64 0-1.16-.49-1.16-1.11s.51-1.11 1.16-1.11c.64 0 1.16.49 1.16 1.11 0 .58-.51 1.11-1.16 1.11zm4.12 0c-.64 0-1.16-.49-1.16-1.11s.51-1.11 1.16-1.11c.64 0 1.16.49 1.16 1.11.03.58-.49 1.11-1.16 1.11zm3.98 0c-.64 0-1.16-.49-1.16-1.11s.51-1.11 1.16-1.11c.64 0 1.16.49 1.16 1.11.03.58-.51 1.11-1.16 1.11zM67.46 47.05H44.41c-1.84 0-3.38 1.45-3.38 3.25 0 1.77 1.51 3.25 3.38 3.25h23.05c1.84 0 3.38-1.45 3.38-3.25.01-1.8-1.53-3.25-3.38-3.25zm-13.52 4.5h-9v-2h9v2zm4.73.23c-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11.64 0 1.16.49 1.16 1.11.03.61-.52 1.11-1.16 1.11zm4.14 0c-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11s1.16.49 1.16 1.11-.51 1.11-1.16 1.11zm3.99 0c-.64 0-1.16-.49-1.16-1.11 0-.62.51-1.11 1.16-1.11.64 0 1.16.49 1.16 1.11s-.52 1.11-1.16 1.11zM67.59 61.05c1.84 0 3.38-1.45 3.38-3.25 0-1.77-1.51-3.25-3.38-3.25H44.54c-1.84 0-3.38 1.45-3.38 3.25 0 1.77 1.51 3.25 3.38 3.25h10.9v3h-1.5v2h-12v2h12v1.5h5v-1.5h11v-2h-11v-2h-1.5v-3h10.15zm-.73-4.62c.64 0 1.16.49 1.16 1.11 0 .62-.51 1.11-1.16 1.11-.64 0-1.16-.49-1.16-1.11.01-.61.52-1.11 1.16-1.11zm-3.98 0c.64 0 1.16.49 1.16 1.11 0 .62-.51 1.11-1.16 1.11-.64 0-1.16-.49-1.16-1.11 0-.61.52-1.11 1.16-1.11zm-4.12 0c.64 0 1.16.49 1.16 1.11 0 .62-.51 1.11-1.16 1.11-.64 0-1.16-.49-1.16-1.11-.02-.61.49-1.11 1.16-1.11zm-4.82 2.12h-9v-2h9v2z'
      />
    </g>
    <path
      className='company_svg__st12'
      d='M64.9 196.62h-9.8c-.34 0-.62.28-.62.62v28.75c0 .34.28.62.62.62h9.79c.34 0 .62-.28.62-.62v-28.75a.608.608 0 00-.61-.62zM60 221.14c-1.2 0-2.18-.98-2.18-2.18 0-1.2.98-2.18 2.18-2.18 1.2 0 2.18.98 2.18 2.18 0 1.21-.98 2.18-2.18 2.18zm4.01-11.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .35-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.11c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm15.25-.73c0-.29-.25-.55-.55-.58-2.9-.26-5.81-.53-8.71-.79-.03 0-.12 0-.22.03l-3.39.86v26.67l3.51.5c.04.01.1 0 .1 0 2.9-.26 5.81-.56 8.71-.82.31-.03.55-.29.55-.58v-25.29zm-8.48 1.83c0-.32.25-.55.55-.53l6.02.42c.31.02.55.28.55.58v.54c0 .3-.25.52-.55.51-2.01-.11-4.01-.23-6.02-.34a.6.6 0 01-.55-.6v-.58zm7.13 9.09c0 .3-.25.54-.55.54l-6.02.06a.55.55 0 01-.55-.56v-.57c0-.32.25-.57.55-.57 2.01.01 4.01.01 6.02.02.31 0 .55.24.55.54v.54zm-.56-2.16c-2.01-.02-4.01-.05-6.02-.07-.31 0-.55-.26-.55-.58v-.57c0-.32.25-.56.55-.56l6.02.15c.31.01.55.26.55.55v.54c.01.3-.24.54-.55.54zm.56-3.23c0 .3-.25.53-.55.52l-6.02-.21a.577.577 0 01-.55-.59v-.57c0-.32.25-.56.55-.54 2.01.1 4.01.19 6.02.29.31.01.55.27.55.57v.53zm-27.9-6.9l-8.71.79c-.31.03-.55.29-.55.58v25.27c0 .29.25.55.55.58 2.9.26 5.81.56 8.71.82 0 0 .06.01.1 0l3.51-.5v-26.67l-3.39-.86c-.1-.01-.19-.02-.22-.01zm-.79 12.33c0 .32-.25.57-.55.56l-6.02-.07c-.31 0-.55-.25-.55-.54v-.54c0-.3.25-.54.55-.54 2.01 0 4.01-.01 6.02-.02.31 0 .55.25.55.57v.58zm0-2.85c0 .32-.25.57-.55.58-2.01.02-4.01.05-6.02.07-.31 0-.55-.23-.55-.53v-.54c0-.3.25-.55.55-.55l6.02-.15c.31-.01.55.24.55.56v.56zm0-2.86c0 .32-.25.58-.55.59l-6.02.21a.518.518 0 01-.55-.52v-.54c0-.3.25-.55.55-.57 2.01-.1 4.01-.19 6.02-.29.31-.01.55.23.55.54v.58zm0-2.85a.6.6 0 01-.55.6c-2.01.11-4.01.23-6.02.34a.505.505 0 01-.55-.51v-.54c0-.3.25-.56.55-.58l6.02-.42c.31-.02.55.22.55.53v.58zm0 0M156.9 196.62h-9.79c-.34 0-.62.28-.62.62v28.75c0 .34.28.62.62.62h9.79c.34 0 .62-.28.62-.62v-28.75c0-.34-.28-.62-.62-.62zm-4.9 24.52c-1.2 0-2.18-.98-2.18-2.18 0-1.2.98-2.18 2.18-2.18 1.2 0 2.18.98 2.18 2.18 0 1.21-.98 2.18-2.18 2.18zm4.01-11.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .35-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.11c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm15.25-.73c0-.29-.25-.55-.55-.58-2.9-.26-5.81-.53-8.71-.79-.03 0-.12 0-.22.03l-3.39.86v26.67l3.51.5c.04.01.1 0 .1 0 2.9-.26 5.81-.56 8.71-.82.31-.03.55-.29.55-.58v-25.29zm-8.48 1.83c0-.32.25-.55.55-.53l6.02.42c.31.02.55.28.55.58v.54c0 .3-.25.52-.55.51-2.01-.11-4.01-.23-6.02-.34a.6.6 0 01-.55-.6v-.58zm7.13 9.09c0 .3-.25.54-.55.54l-6.02.06a.55.55 0 01-.55-.56v-.57c0-.32.25-.57.55-.57 2.01.01 4.01.01 6.02.02.31 0 .55.24.55.54v.54zm-.56-2.16c-2.01-.02-4.01-.05-6.02-.07-.31 0-.55-.26-.55-.58v-.57c0-.32.25-.56.55-.56l6.02.15c.31.01.55.26.55.55v.54c.01.3-.24.54-.55.54zm.56-3.23c0 .3-.25.53-.55.52l-6.02-.21a.577.577 0 01-.55-.59v-.57c0-.32.25-.56.55-.54 2.01.1 4.01.19 6.02.29.31.01.55.27.55.57v.53zm-27.9-6.9l-8.71.79c-.31.03-.55.29-.55.58v25.27c0 .29.25.55.55.58 2.9.26 5.81.56 8.71.82 0 0 .06.01.1 0l3.51-.5v-26.67l-3.39-.86c-.1-.01-.19-.02-.22-.01zm-.79 12.33c0 .32-.25.57-.55.56l-6.02-.07c-.31 0-.55-.25-.55-.54v-.54c0-.3.25-.54.55-.54 2.01 0 4.01-.01 6.02-.02.31 0 .55.25.55.57v.58zm0-2.85c0 .32-.25.57-.55.58-2.01.02-4.01.05-6.02.07-.31 0-.55-.23-.55-.53v-.54c0-.3.25-.55.55-.55l6.02-.15c.31-.01.55.24.55.56v.56zm0-2.86c0 .32-.25.58-.55.59l-6.02.21a.518.518 0 01-.55-.52v-.54c0-.3.25-.55.55-.57 2.01-.1 4.01-.19 6.02-.29.31-.01.55.23.55.54v.58zm0-2.85a.6.6 0 01-.55.6c-2.01.11-4.01.23-6.02.34a.505.505 0 01-.55-.51v-.54c0-.3.25-.56.55-.58l6.02-.42c.31-.02.55.22.55.53v.58zm0 0M246.9 196.62h-9.79c-.34 0-.62.28-.62.62v28.75c0 .34.28.62.62.62h9.79c.34 0 .62-.28.62-.62v-28.75c0-.34-.28-.62-.62-.62zm-4.9 24.52c-1.2 0-2.18-.98-2.18-2.18 0-1.2.98-2.18 2.18-2.18 1.2 0 2.18.98 2.18 2.18 0 1.21-.98 2.18-2.18 2.18zm4.01-11.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.12c0 .35-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.34.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm0-3.11c0 .34-.28.62-.62.62h-6.77c-.34 0-.62-.28-.62-.62v-.62c0-.35.28-.62.62-.62h6.77c.34 0 .62.28.62.62v.62zm15.25-.73c0-.29-.25-.55-.55-.58-2.9-.26-5.81-.53-8.71-.79-.03 0-.12 0-.22.03l-3.39.86v26.67l3.51.5c.04.01.1 0 .1 0 2.9-.26 5.81-.56 8.71-.82.31-.03.55-.29.55-.58v-25.29zm-8.48 1.83c0-.32.25-.55.55-.53l6.02.42c.31.02.55.28.55.58v.54c0 .3-.25.52-.55.51-2.01-.11-4.01-.23-6.02-.34a.6.6 0 01-.55-.6v-.58zm7.13 9.09c0 .3-.25.54-.55.54l-6.02.06a.55.55 0 01-.55-.56v-.57c0-.32.25-.57.55-.57 2.01.01 4.01.01 6.02.02.31 0 .55.24.55.54v.54zm-.56-2.16c-2.01-.02-4.01-.05-6.02-.07-.31 0-.55-.26-.55-.58v-.57c0-.32.25-.56.55-.56l6.02.15c.31.01.55.26.55.55v.54c.01.3-.24.54-.55.54zm.56-3.23c0 .3-.25.53-.55.52l-6.02-.21a.577.577 0 01-.55-.59v-.57c0-.32.25-.56.55-.54 2.01.1 4.01.19 6.02.29.31.01.55.27.55.57v.53zm-27.9-6.9l-8.71.79c-.31.03-.55.29-.55.58v25.27c0 .29.25.55.55.58 2.9.26 5.81.56 8.71.82 0 0 .06.01.1 0l3.51-.5v-26.67l-3.39-.86c-.1-.01-.19-.02-.22-.01zm-.79 12.33c0 .32-.25.57-.55.56l-6.02-.07c-.31 0-.55-.25-.55-.54v-.54c0-.3.25-.54.55-.54 2.01 0 4.01-.01 6.02-.02.31 0 .55.25.55.57v.58zm0-2.85c0 .32-.25.57-.55.58-2.01.02-4.01.05-6.02.07-.31 0-.55-.23-.55-.53v-.54c0-.3.25-.55.55-.55l6.02-.15c.31-.01.55.24.55.56v.56zm0-2.86c0 .32-.25.58-.55.59l-6.02.21a.518.518 0 01-.55-.52v-.54c0-.3.25-.55.55-.57 2.01-.1 4.01-.19 6.02-.29.31-.01.55.23.55.54v.58zm0-2.85a.6.6 0 01-.55.6c-2.01.11-4.01.23-6.02.34a.505.505 0 01-.55-.51v-.54c0-.3.25-.56.55-.58l6.02-.42c.31-.02.55.22.55.53v.58zm0 0'
    />
    <g>
      <path className='company_svg__st7' d='M135 278.22v25h16v3h-6v2h13v-2h-5v-3h15v-25h-33zm2 23v-21h29v21h-29z' />
      <path className='company_svg__st7' d='M141 284.22h7v2h-7zM141 289.22h13v2h-13zM141 294.22h20v2h-20z' />
    </g>
  </svg>
)

export default SvgCompany
